@if (breadcrumbs && breadcrumbs.length >0) {
<div class="breadcrumb-nav">
  <nav class="text-sm p-2 flex flex-wrap items-center gap-1 font-semibold">
    @for (bc of breadcrumbs; track bc; let last = $last; let first = $first) {
    @if (!last) {
    <a [routerLink]="bc.url" class="text-dc-dark-blue underline underline-offset-4 inline-flex items-center">
      {{ bc.rawLabel ? bc.label : ("BREADCRUMBS." + bc.label | translate) }}
    </a>
    } @if (!last) {
    <span class="inline-flex items-center">
     <img src="/icons/svg/chevron-right.svg" class="inline-block">
    </span>
    } @if (last) {
    <span class="inline-flex items-center">
      @if(breadcrumbs && breadcrumbs.length < 2){
      <a [routerLink]="bc.url" class="text-dc-black underline underline-offset-4 inline-flex items-center">
        {{ bc.rawLabel ? bc.label : ("BREADCRUMBS." + bc.label | translate) }}
      </a>
      }@else {
      <a class="text-dc-black underline underline-offset-4 inline-flex items-center">
        {{ bc.rawLabel ? bc.label : ("BREADCRUMBS." + bc.label | translate) }}
      </a>
      }
    </span>
    } }
  </nav>
</div>
}
